import React from "react";

export const BgLanding = () =>{
    return(
        <div className="bg-landing">
        </div>
    )
}